//tricker sellect option
$(document).ready(function(){
  $('.input-value span').click(function(){
    if($(this).hasClass('product-page__size-selection--selected')){
      $(this).removeClass('product-page__size-selection--selected');
    }else{
      $('.input-value span').removeClass('product-page__size-selection--selected');
      $(this).addClass('product-page__size-selection--selected');
    }
    //-----------------------------------
    let values = $('.product-page__size-selection--selected').text();
    $('.Size .selected-text .size-guiz').text(values);
    $('.Size .option-selector-value option').each(function( ){
      let values = $('.product-page__size-selection--selected').text();
      let valueOption = $(this).attr('value');
      if( values == valueOption ){
        $('.Size .option-selector-value').val(values).change();
      }
    });
  });
  
});
//sticky description product
$(document).ready(function(){
  var hT = $('.product-details-wrapper-thumbnails').height();
  var h = $(window).height();
  var top = hT - h;
  $('.product-details-wrapper-thumbnails').css('top', -top)
});
// silder product image
$(document).ready(function(){
  $('.product-image-thumbnails .product-gallery--viewport--figure ').click(function(){
    if( $(this).hasClass('product-image-forloop') ){
      $(this).removeClass('product-image-forloop');
    }else{
      $('.product-image-thumbnails .product-gallery--viewport--figure').removeClass('product-image-forloop');
      $(this).addClass('product-image-forloop');
    }
    var x = $('.product-image-thumbnails .product-image-forloop').attr('data-forloop');
    $('.product-gallery--viewport .product-gallery--viewport--figure ').each(function(){
      var dataForlopp = $('.product-image-thumbnails .product-image-forloop').attr('data-forloop');
      var top = $(this).offset().top;
      if( dataForlopp == $(this).attr('data-forloop') ){
        $([document.documentElement, document.body]).animate({
          scrollTop: top
        },700);
      }
    });
  })
});
// sticky product image thumbnails
$(window).scroll(function(){
  var headerHegiht = $('.sticky-header .header-main-content').height();
  $('.product-image-thumbnails-content').css('top',headerHegiht );
});
$(document).ready(function(){
  $('.mobile-mega-nav .navigation-submenu-toggle').click(function(){
    if($(this).hasClass('navigation-submenu-toggle-active')){
      $(this).removeClass('navigation-submenu-toggle-active');
      $(this).parents('.mobile-mega-nav .has-dropdown').removeClass('has-dropdown-active');
    }else{
      $(this).addClass('navigation-submenu-toggle-active');
      $(this).parents('.mobile-mega-nav .has-dropdown').addClass('has-dropdown-active');
    }
  })
});

$(document).ready(function(){
  toggle__humberger_menu();
  $(window).resize(function(){
    toggle__humberger_menu();
  });
});

function toggle__humberger_menu(){
  let windowWidth = $(window).width();
  if( windowWidth <= 1079 && windowWidth >= 769 ){
    $('.navigation-toggle-open').click(function(){
      $('.navigation-wrapper').addClass('height-wrapper');
      $('.navigation-has-mega-nav').addClass('navigation-mobile').removeClass('navigation-desktop');
      $('.main-content').addClass('main-content-opacity');
      $('.has-mega-nav').addClass('has-dropdown')
    });
    $('.navigation-toggle-close').click(function(){
      $('.navigation-wrapper').removeClass('height-wrapper');
       $('.navigation-has-mega-nav').removeClass('navigation-mobile').addClass('navigation-desktop');
      $('.main-content').removeClass('main-content-opacity');
    });
    if($('section.header').hasClass('header-border')){
      $('section.header').removeClass('header-border')
    }

    $('.has-dropdown .navigation-submenu-toggle').click(function(){
      if($(this).parents('.has-dropdown').hasClass('has-mobile-dropdown--active')){
        $(this).parents('.has-dropdown').removeClass('has-mobile-dropdown--active');
      }else{
        $(this).parents('.has-dropdown').addClass('has-mobile-dropdown--active');
      }
    });
	
    $('.has-mega-nav .navigation-submenu-toggle').click(function(){
    	var $this = $(this).parents('.has-mega-nav');
      if ( $this.hasClass( 'has-mobile-dropdown--active' ) ){
      	$this.removeClass( 'has-mobile-dropdown--active' );
      }else{
      	$this.addClass( 'has-mobile-dropdown--active' );
      }
    });
    
    $('#navigation-womens').click(function(event){
    	event.preventDefault()
    });
    
  }
}

$(document).ready(function(){
    setTimeout(function(){
      $('.curentcy-convert').append($('.doubly-wrapper').html()) 
    }, 3000);
});